import React from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './styles.module.scss';

const Select = (props) => {
  const {
    id,
    children,
    white,
    className,
    selectedBlue,
    ...rest
  } = props;
  return (
    <div
      id={id ? id : ''}
      className={classNames({
        [styles.selectContainer]: true,
        [styles.selectContainerWhite]: white,
        [className]: className,
        [styles.selectContainerScienceBlue]: selectedBlue && rest.value
      })}
    >
      <select {...rest}>
        {children}
      </select>
      <FontAwesomeIcon icon={['far', 'chevron-down']} />
    </div>
  );
};

export default Select;
